
import { BehaviorSubject } from 'rxjs';

export const behaviorCreateBundle$ = new BehaviorSubject({});

export const behaviorCreateBundle = behaviorCreateBundle$.asObservable();